module.exports = __webpack_public_path__ + "static/media/ecomm.b2f7f916.png";